<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span
        >询盘数量统计 <span v-if="getTotal">{{ `(${getTotal})` }}</span></span
      >
      <sky-dropdown-select
        style="float: right; padding: 3px 0"
        default-text="全部站点"
        :options="options"
        @input="input"
      ></sky-dropdown-select>
    </div>
    <ve-line :data="chartConf.data" :settings="chartConf.config"></ve-line>
  </el-card>
</template>

<script>
import VeLine from 'v-charts/lib/line.common';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import inquiry from '@/backend/services/enquiry/enquiry';
import { websiteType } from '@/common/dictionary';
import mixin from './mixin';
export default {
  name: 'enquiryCount',
  components: {
    VeLine,
    skyDropdownSelect,
  },
  mixins: [mixin],
  data() {
    return {
      options: websiteType,
      data: [],
    };
  },
  computed: {
    getTotal() {
      return this.data.reduce((result, currentVal) => {
        return result + currentVal.num;
      }, 0);
    },
  },
  methods: {
    async query(val) {
      let data = await inquiry.inquiryTrend({
        ...this.getCommon(),
        websiteType: val,
      });
      this.data = data.data;
      this.chartConf.data.rows = data.data;
    },
    input(val) {
      this.query(val);
    },
  },
};
</script>

<style scoped></style>
